import React, { FC } from 'react'
import { observer } from 'mobx-react'
import appMobx from '@mobx/app/app.mobx'
import './index.scss'

// props
interface IProps {
  orderAddTime: number;
  endTips: string;
  downTips: (time: string) => string;
}

const tommss = (addTime: number, now: number) => {
  const calc = Number(((now - addTime) / 1000).toFixed())
  let s = '0'
  if (calc > 0) {
    const time = 15 * 60 - calc
    if (time > 0 && !isNaN(time)) {
      let minutes = parseInt(String(time / 60))
      let seconds = time % 60
      s = (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)
    }
  }
  return s
}

const CountDown: FC<IProps> = ({ orderAddTime, endTips, downTips }) => {
  const lastTime = tommss(orderAddTime, appMobx.now)
  return (
    <span>{lastTime === '0' ? endTips : downTips(lastTime)}</span>
  )
}

export default observer(CountDown)
